<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs/>
        <section id="message" class="flex items-center justify-center text-center">
            <div class=" flex flex-col items-center justify-center">
                <img src="@img/defaults/error.webp" title="error" alt="error"
                     class="mb-5 h-[200px] md:h-[300px] w-auto">
                <h1 class="text-2xl md:text-3xl font-bold mb-2">{{ title }}</h1>
                <div class="max-md:text-sm font-medium mb-4">{{ description }}</div>
                <p class="h6 font-medium">
                    <Link :href="route('home')"
                          class="flex justify-center items-center w-full text-white border-2 border-baseColor bg-baseColor md:hover:bg-transparent md:hover:text-baseColor font-bold rounded-lg text-sm px-14 py-2.5 focus:outline-none transition">
                        На главную страницу
                    </Link>
                </p>
            </div>
        </section>
    </div>
</template>

<script>
import {computed, defineProps} from 'vue';
import {Link} from "@inertiajs/vue3";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";

export default {
    props: {
        status: Number
    },
    setup(props) {
        const title = computed(() => {
            return {
                503: '503: Сервис временно недоступен',
                500: '500: Ошибка сервера',
                404: '404: Страница не найдена',
                403: '403: Доступ запрещён',
            }[props.status];
        });

        const description = computed(() => {
            return {
                503: 'Извините, мы проводим техническое обслуживание. Пожалуйста, зайдите позже.',
                500: 'Упс, что-то пошло не так на наших серверах.',
                404: 'Извините, страница, которую вы ищете, не найдена.',
                403: 'Извините, у вас нет доступа к этой странице.',
            }[props.status];
        });

        const status = props.status
        return {
            title,
            description,
            status,
        };
    },
    components: {
        MobileTopBar,
        Breadcrumbs,
        Link
    }
};
</script>
